import { BASE_URL,  USERS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IAssignedDoctors, IAssignedUsers, IQUser, IQUserDetails, ITeethImage, ITeethVideo, ITreatments, IUser, IUserActivity, IUserInput } from "models/user";
import { ApiResponse } from "./auth";


export async function getUsers(params: string = "") : Promise<ApiResponse<IUser[]>> {
  const response = await axios.get(BASE_URL + USERS + params);
  return response.data;
}

export async function getListOFImagesFiltered(params: string = "") : Promise<ApiResponse<ITeethImage[]>> {
  const response = await axios.get(BASE_URL + "api/Aligner/getImagesByDate" + params);
  return response.data;
}

export async function getListOFVideosFiltered(params: string = "") : Promise<ApiResponse<ITeethVideo[]>> {
  const response = await axios.get(BASE_URL + "api/Aligner/getVideosByDate" + params);
  return response.data;
}

export async function getUsersWithoutDoctors(params: string = "") : Promise<ApiResponse<IUser[]>> {
  const response = await axios.get(BASE_URL + "api/Users/users/" + params);
  return response.data;
}

export async function getQUsers(params: string = "") : Promise<ApiResponse<IQUser[]>> {
  const response = await axios.get(BASE_URL + "api/EConsultationQuestions/geteconsultationusers" + params);
  return response.data;
}

export async function getQDetails(params: string = "") : Promise<ApiResponse<IQUserDetails>> {
  const response = await axios.get(BASE_URL + "api/EConsultationQuestions/GetEconsultationDetails/" + params);
  return response.data;
}

export async function getUser(params: string = "") : Promise<ApiResponse<IUser>> {
  const response = await axios.get(BASE_URL + "api/Users/users/" + params);
  return response.data;
}

export async function getAvailableDatesForTreatment(params: string = "") : Promise<ApiResponse<string[]>> {
  const response = await axios.get(BASE_URL + "api/Aligner/getUploadDatesByTreatment/" + params);
  return response.data;
}

export async function getAssignedUsers(params: string = "") : Promise<ApiResponse<IAssignedUsers[]>> {
  const response = await axios.get(BASE_URL + "api/Doctor/getDoctorPatients/" + params);
  return response.data;
}

export async function getAssignedDoctors(params: string = "") : Promise<ApiResponse<IAssignedDoctors[]>> {
  const response = await axios.get(BASE_URL + "api/Users/getPatientDoctors/" + params);
  return response.data;
}

export async function getPatientTreatments(params: string = "") : Promise<ApiResponse<ITreatments[]>> {
  const response = await axios.get(BASE_URL + "api/Aligner/getTreatmentsByPatient/" + params);
  return response.data;
}

export async function getUserActivity(params: string = "") : Promise<ApiResponse<IUserActivity>> {
  const response = await axios.get(BASE_URL + "api/Aligner/getTreatmentSummaryAndLogs/" + params);
  return response.data;
}

export async function addUser(data: FormData) {
  const response = await axios.post(BASE_URL + "api/Users/users/" , data ,{
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
}

export async function assignUser(data: {doctorID: number,patientID: number}) {
  const response = await axios.post(BASE_URL + "api/Doctor/assignPatient", data);
  return response.data;
}

export async function unassignUser(data: {doctorID: number,patientID: number}) {
  const response = await axios.post(BASE_URL + "api/Doctor/removeAssignPatient", data);
  return response.data;
}

export async function changePassword(data: {newPassword: string,userId: string}) {
  const response = await axios.post(BASE_URL + "api/Auth/changePassword", data);
  return response.data;
}


export async function editUser(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + "api/Users/users/" + id , data ,{
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
}

export async function editUserProfile(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + "api/Users/users/" + id +"/profile" , data ,{
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
}

export async function deleteUser(id: string) {
  const response = await axios.delete(BASE_URL + "api/Users/users/" + id);
  return response.data;
}


export const UsersCells: HeadCell[] = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: false,
    label: "Name",
    
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "contactNumber",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
  },
  {
    id: "dateOfBirth",
    numeric: false,
    disablePadding: false,
    label: "Date Of Birth",
  },
  {
    id: "countryName",
    numeric: false,
    disablePadding: false,
    label: "Country Name",
  },
  {
    id: "cityName",
    numeric: false,
    disablePadding: false,
    label: "City Name",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];


export const QUsersCells: HeadCell[] = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: false,
    label: "Name",
    
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "contactNumber",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
  },
  {
    id: "dateOfBirth",
    numeric: false,
    disablePadding: false,
    label: "Date Of Birth",
  },
  {
    id: "countryName",
    numeric: false,
    disablePadding: false,
    label: "Country Name",
  },
  {
    id: "cityName",
    numeric: false,
    disablePadding: false,
    label: "City Name",
  },
  {
    id: "notes",
    numeric: false,
    disablePadding: false,
    label: "Notes",
  },
  {
    id: "referralSource",
    numeric: false,
    disablePadding: false,
    label: "Referral Source",
  },
  {
    id: "address",
    numeric: false,
    disablePadding: false,
    label: "Address",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];


export const QUsersCellsDetails: HeadCell[] = [
  {
    id: "questionID",
    numeric: false,
    disablePadding: false,
    label: "Question ID",
    
  },
  {
    id: "questionText",
    numeric: false,
    disablePadding: false,
    label: "Question Text",
  },
  // {
  //   id: "questionDescription",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Question Description",
  // },
  // {
  //   id: "questionImagePath",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Image",
  // },
  {
    id: "answer",
    numeric: false,
    disablePadding: false,
    label: "Answer",
  },
  {
    id: "answerDate",
    numeric: false,
    disablePadding: false,
    label: "Answer Date",
  }
];



export const AssignedUsersCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Name",
    
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "contactNumber",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
  }
];


export const AssignedDoctorsCells: HeadCell[] = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: false,
    label: "First Name",
    
  },
  {
    id: "lastName",
    numeric: false,
    disablePadding: false,
    label: "Last Name",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
  }
];

export const TreatmentsCells: HeadCell[] = [
  {
    id: "StartDate",
    numeric: false,
    disablePadding: false,
    label: "Start Date",
    
  },
  {
    id: "Duration",
    numeric: false,
    disablePadding: false,
    label: "Duration",
  },
  {
    id: "CurrentStatus",
    numeric: false,
    disablePadding: false,
    label: "Current Status",
  },
  {
    id: "AlignersCount",
    numeric: false,
    disablePadding: false,
    label: "Aligners Count",
  },
  {
    id: "GoalInHours",
    numeric: false,
    disablePadding: false,
    label: "Goal In Hours",
  },
  {
    id: "ImageUploadFrequency",
    numeric: false,
    disablePadding: false,
    label: "Image Upload Frequency",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
  }
];

export const UserActivityCells: HeadCell[] = [
  {
    id: "startTime",
    numeric: false,
    disablePadding: false,
    label: "Start Time",
    
  },
  {
    id: "endTime",
    numeric: false,
    disablePadding: false,
    label: "End Time",
  },
  {
    id: "durationMinutes",
    numeric: false,
    disablePadding: false,
    label: "Duration Minutes",
  },
  {
    id: "manualEntry",
    numeric: false,
    disablePadding: false,
    label: "Manual Entry",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  }
];